import React, { useState } from 'react';
import { IconButton, Tooltip, Menu, MenuItem, useTheme as useMuiTheme } from '@mui/material';
import { Brightness4, Brightness7, Computer } from '@mui/icons-material';
import { useTheme } from '../utils/ThemeContext';

const ThemeToggle = () => {
  const { themeMode, setThemeMode, isDarkMode } = useTheme();
  const theme = useMuiTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleThemeChange = (newTheme) => {
    setThemeMode(newTheme);
    handleClose();
  };

  const getThemeIcon = () => {
    if (themeMode === 'system') {
      return <Computer sx={{ color: theme.palette.primary.main }} />;
    }
    return isDarkMode ? (
      <Brightness7 sx={{ color: theme.palette.primary.light }} />
    ) : (
      <Brightness4 sx={{ color: theme.palette.primary.main }} />
    );
  };

  return (
    <>
      <Tooltip title="Theme Settings">
        <IconButton
          onClick={handleClick}
          color="inherit"
          sx={{
            transition: 'transform 0.2s',
            '&:hover': {
              transform: 'scale(1.1)',
            },
          }}
        >
          {getThemeIcon()}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => handleThemeChange('light')} selected={themeMode === 'light'}>
          <Brightness4 sx={{ mr: 1 }} /> Light
        </MenuItem>
        <MenuItem onClick={() => handleThemeChange('dark')} selected={themeMode === 'dark'}>
          <Brightness7 sx={{ mr: 1 }} /> Dark
        </MenuItem>
        <MenuItem onClick={() => handleThemeChange('system')} selected={themeMode === 'system'}>
          <Computer sx={{ mr: 1 }} /> System
        </MenuItem>
      </Menu>
    </>
  );
};

export default ThemeToggle; 